// @ts-check

import React from 'react';
import { bool } from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * @component LoadingBackdrop
 * @param {Object} props
 * @param {boolean} props.open
 * @returns {JSX.Element}
 */
function LoadingBackdrop({ open }) {
	return (
		<Backdrop
			sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
			open={open}
		>
			<CircularProgress color="primary" size={80} thickness={4} />
		</Backdrop>
	);
}

LoadingBackdrop.propTypes = { open: bool };

export default LoadingBackdrop;
